/* global process */

// Top-level configuration for the App. Takes most variables from ENV files,
// sourced via dotenv

const testDefault = (actual: string | undefined, test: string) =>
  process.env.NODE_ENV === 'test' ? test : actual

const STARGATE_API = testDefault(process.env.STARGATE_API, 'http://localhost')
const HODOR_API = testDefault(process.env.HODOR_API, 'http://localhost')
const HOMEWEB_URL = process.env.HOMEWEB_URL || 'ERROR_NO_HOME_WEB_URL_SET'
const PLAYGROUND_URL = process.env.PLAYGROUND_URL || 'ERROR_NO_PLAYGROUND_WEB_URL_SET'
const PRODADMIN_API = testDefault(process.env.PRODADMIN_API, 'http://localhost')
const GOOGLE_ANALYTICS_PROPERTY = testDefault(process.env.GOOGLE_ANALYTICS_PROPERTY, 'UA-123456-1')
const GOOGLE_TAG_MANAGER_ID = testDefault(process.env.GOOGLE_TAG_MANAGER_ID, 'GTM-123456')
const VERSION = testDefault(process.env.VERSION, '1.0.0')

const UNLEASH_URL = 'https://eu.app.unleash-hosted.com/eubb7006/api/frontend/'
const UNLEASH_APP_NAME = 'Stardor'
const UNLEASH_CLIENT_KEY = process.env.UNLEASH_CLIENT_KEY

const config = {
  STARGATE_API,
  HODOR_API,
  HOMEWEB_URL,
  PLAYGROUND_URL,
  PRODADMIN_API,
  GOOGLE_ANALYTICS_PROPERTY,
  GOOGLE_TAG_MANAGER_ID,
  VERSION,
  UNLEASH_URL,
  UNLEASH_APP_NAME,
  UNLEASH_CLIENT_KEY,
}

const OPTIONAL_KEYS = ['UNLEASH_CLIENT_KEY']

function validateConfig() {
  Object.entries(config).forEach(([key, value]: [string, Nullable<string>]) => {
    if (OPTIONAL_KEYS.includes(key)) return
    if (value === null || value === undefined) {
      throw Error(
        `App not configured correctly - missing environment variable: ${key}.
        If running locally: Have you configured your .env?`
      )
    }
  })
}

validateConfig()

export default config
